import classNames from "classnames";
import colourStyle from "./EnhancedSearchResults.module.scss";
import style from "./EnhancedSearchSideBar.module.scss";

import PropTypes from "prop-types";

const GuidelineFacet = ({ guideline, resultCount, selected, clickEvent }) => {
  let iconClassName = guideline.replace(/ /g, "").toLowerCase();

  return (
    <li onClick={clickEvent} className={classNames(style.guidelineContainer, { [style["activeGuideline"]]: selected })}>
      <div className={classNames(colourStyle[iconClassName], style.guidelineIcon)} />
      <div className="size-16 semibold">{guideline}</div>
      <div className={classNames("badge", style.counter)}>{resultCount}</div>
    </li>
  );
};

GuidelineFacet.propTypes = {
  guideline: PropTypes.string,
  resultCount: PropTypes.number,
  selected: PropTypes.bool,
  clickEvent: PropTypes.func,
};

export default GuidelineFacet;